<template>
  <table class="table table-striped border-light">
    <thead>
    <tr>
      <th colspan="2">
        <h5 class="mb-0 text-center text-capitalize-first">
          {{ helper.trans('labels.crypto_transaction')}}
        </h5>
      </th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <th class="text-capitalize-first">{{ helper.trans('labels.address.default') }}</th>
      <td>{{ transaction?.address }} <copy-button :value="transaction?.address"></copy-button></td>
    </tr>
    <tr>
      <th class="text-capitalize-first">{{ helper.trans('labels.sum') }}</th>
      <td>
        {{ numberFormatter.formatMoney(transaction?.sum) }}
      </td>
    </tr>
    <tr>
      <th class="text-capitalize-first">{{ helper.trans('labels.fee') }}</th>
      <td>
        {{ transaction?.fee ? numberFormatter.formatMoney(transaction?.fee) : 'n/a' }}
      </td>
    </tr>
    <tr>
      <th class="text-capitalize-first">{{ helper.trans('labels.tx_id') }}</th>
      <td>
        <div v-if="transaction?.txId">
          <a :href="helper.explorerTx(transaction?.sum.currency, transaction.txId)" target="_blank">{{truncateTxId(transaction.txId)}}</a>
          <copy-button class="ms-1" :value="transaction.txId"></copy-button>
        </div>
        <div v-else>
          n/a
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script lang="ts">

import {computed, defineComponent, onMounted, Prop, PropType, reactive, ref, toRefs} from 'vue'
import {helper, truncateTxId} from "@/service/CommonHelper";
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import CopyButton from "@/components/CopyButton.vue";
import TransferTransactionDTO from "@/models/TransferTransactionDTO";

export default defineComponent({
  components: {
    CopyButton,
  },
  props: {
    transaction: {
      type: Object as PropType<TransferTransactionDTO>,
      required: true
    } as Prop<TransferTransactionDTO>
  },
  setup(props) {

    return {
      dateHelper,
      numberFormatter,
      helper,
      truncateTxId
    }
  }
})
</script>
